import Loader from 'semantic-ui-react/dist/commonjs/elements/Loader';
import '@purple/semantic-ui-purple-theme/components/loader.css';

export default Loader;
